/*@ngInject*/
const DiscardModificationsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.discardModifications = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/discardModifications';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('discardModificationsRepository', DiscardModificationsRepository);
